module.exports = __webpack_public_path__ + "img/cart-empty.7939d2fa.png";